<template>
  <SSection
    v-for="(item, index) in items"
    :key="index"
    :title="item.title"
    :has-separator="false"
  >
    <SLinks :items="item.links.items" />
  </SSection>
</template>
<script setup lang="ts">
import type { propsInterface as sLinksProps } from '~~/modules/design-system/sections/s-links/s-links.vue'

type sLinks = {
  title?: string
  links: sLinksProps
}

export interface propsInterface {
  items: sLinks[]
}

defineProps<propsInterface>()
</script>
